require('../../dplayer')
var VueDPlayer = {
  props: {
    options: {
      type: Object
    }
  },
  data: function data () {
    return {
      dp: null
    }
  },
  mounted: function mounted () {
    var this$1 = this
    
    this.options.container = this.$el.querySelector('.dplayer_box')
    var player = this.dp = new DPlayer(this.options)
    var events = player.events
    Object.keys(events).forEach(function (item) {
      if (item === 'events') {
        return false
      } else {
        events[item].forEach(function (event) {
          player.on(event, function () { return this$1.$emit(event) })
        })
      }
    })
  },
  install: function install (Vue, ref) {
    if (ref === void 0) ref = {}
    var name = ref.name
    if (name === void 0) name = 'd-player'
    console.log('Vue.component this', this)
    Vue.component(name, this)
  },
  render: function render (h) {
    return h('div', {
      class: 'dplayer my-dplayer'
    }, [this.$slots.default, h('div', { class: 'dplayer_box' })])
  }
}

export default VueDPlayer
